import {useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {HomeEnum, MyAppointmentsEnum, PlanTypeEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages';

const {title, detailsTitle, historyDetailsTitle, historySurgeryDetailsTitle} =
	translations['pt-br'].privateFlow.myAppointments;

export function useMyAppointments() {
	const {pathname, state: routeState} = useLocation();
	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();

	const {beneficiary} = useAccountDataStore(store => store.accountData);

	const isOdonto = beneficiary.tipoPlanoC === PlanTypeEnum.ODONTO;

	const {isValid} = useContractStatus();

	const isDetailPath = pathname.includes('detalhes-do-agendamento');
	const isSurgeryHistoryDetailPath = pathname.includes('detalhes-da-cirurgia');
	const isHistoryDetailPath =
		pathname.includes('detalhes-da-consulta') || isSurgeryHistoryDetailPath;
	const hideTabs = isDetailPath || isHistoryDetailPath || isOdonto || !isValid;

	const pageTitle = () => {
		if (isDetailPath) {
			return detailsTitle;
		}

		if (isHistoryDetailPath) {
			return isSurgeryHistoryDetailPath ? historySurgeryDetailsTitle : historyDetailsTitle;
		}

		return title;
	};

	const handleBack = useCallback(() => {
		if (isDetailPath) {
			navigate(MyAppointmentsEnum.MY_APPOINTMENTS);
		} else if (isHistoryDetailPath) {
			navigate(MyAppointmentsEnum.MY_APPOINTMENTS_HISTORY);
		} else if (routeState && routeState.includes('/servicos')) {
			navigate(routeState);
		} else {
			navigate(HomeEnum.HOME_PAGE);
		}
	}, [isDetailPath, isHistoryDetailPath, routeState]);

	return {
		pageTitle,
		handleBack,
		hideTabs,
		isMobile,
	};
}
